export const syncCalendar = {
  title: "Synchronisez vos calendriers",
  description:
    "Votre hébergement est-il présent sur plusieurs sites web ? Synchroniser vos calendriers vous aide à voir vos réservations et votre disponibilité sur tous les canaux à la fois. Vous pouvez importer et exporter des calendriers au format iCal et tenir à jour votre liste de check-ins programmés.",
  accommodation: "Hébergement",
  sync: "Synchroniser",
  addCalendar: "Ajouter un nouveau calendrier",
  confirmSync: {
    message: "Voulez-vous mettre à jour les calendriers ?",
  },
  syncSuccess: {
    message: "Calendriers synchronisés avec succès",
    title: "Synchronisation réussie",
  },
  calendarName: "Nom du calendrier",
  modal: {
    header: "Ajouter un calendrier",
    nameLabel: "Saisissez le nom du calendrier",
    linkLabel: "Copiez et collez le lien de votre calendrier ici",
    linkPlaceholder: "Lien iCal",
    cancel: "Annuler",
    save: "Enregistrer et synchroniser",
  },
  saveSuccess: {
    message: "Succès",
    title: "Calendrier enregistré avec succès",
  },
  errors: {
    validationTitle: "Échec de la validation",
    saveErrorTitle: "Erreur lors de l'enregistrement du calendrier",
    unexpected: "Une erreur inattendue s'est produite.",
  },
  list: {
    updated: "Mis à jour",
    status: "Statut",
    synced: "Synchronisé",
    delete: "Supprimer",
    empty: "Aucun calendrier synchronisé",
  },
  deleteConfirm: {
    title: "Voulez-vous supprimer le calendrier ?",
    content:
      'Supprimer le calendrier supprimera également les réservations synchronisées dans le menu "Check-ins programmés (réservations)"',
  },
  deleteSuccess: {
    message: "Calendrier supprimé avec succès",
    title: "Supprimé",
  },
  deleteError: {
    message: "Erreur lors de la suppression du calendrier",
    title: "Erreur",
  },
};
